const size = {
  sm: {
    fontSize: "14px",
    height: "24px",
    borderRadius: "6px",
  },
  md: {
    fontSize: "14px",
    height: "32px",
    borderRadius: "8px",
  },
  lg: {
    fontSize: "16px",
    height: "40px",
    borderRadius: "10px",
  },
};

export const button = {
  size,
};
